<template>
    <div class="multicolor-icon">
        <div>
            <i
                class="fa"
                :class="[iconClass, rightClass]"
                :style="rightStyle"
            ></i>
        </div>
        <div>
            <i
                class="fa"
                :class="[iconClass, leftClass]"
                :style="leftStyle"
            ></i>
        </div>
    </div>
</template>

<script>
export default {
    name : "MultiColoredIcon",
    props : {
        iconClass : {
            type : String,
            required : true,
        },
        leftColor : {
            type : String,
            required : false,
        },
        leftClass : {
            type : String,
            required : false,
        },
        rightColor : {
            type : String,
            required : false,
        },
        rightClass : {
            type : String,
            required : false,
        },
    },
    computed : {
        rightStyle () {
            if(!this.rightColor){
                return;
            }
            return { color : this.rightColor };
        },
        leftStyle () {
            if(!this.leftColor){
                return;
            }
            return { color : this.leftColor };
        },
    }
}
</script>

<style lang="scss" scoped>
    .multicolor-icon {
        display:block;
        clear:both;
        position:relative;

        & > div {
            &:first-child {
                display:block;
            }
            &:last-child {
                left:0;
                position:absolute;
                right:0;
                top:0;
                width:50%;
                overflow:hidden;
            }
        }

    }
</style>
